/*
  MTB-Raceshop: konkreter Liefertag zur Verfügbarkeits-Ampel.
  Füllt Elemente mit [data-liefertag] aus snippets/backorder.liquid (Produktseite, Quick-Add)
  und snippets/ampel-karte.liquid (Artikelkachel). Eingebunden in snippets/doc-head-core.liquid.

  data-liefertag-tage   = Werktage ab Versandtag bis zur Zustellung
                          (Lagerware: 1, Lieferantenware: aus snippets/ampel-tage.liquid)
  data-liefertag-art    = "lager" oder "lieferant"
  data-liefertag-format = "lang" (Produktseite) oder "kurz" (Artikelkachel)
  data-liefertag-schluss = Bestellschluss (Stunde) für Lieferantenware, wenn die Marke einen eigenen hat
                          (seit 01.11.2026, aus snippets/ampel-tage.liquid, z. B. RAD-Marken 13). Sonst 17 Uhr.
  Ohne JavaScript bleibt der Standardtext aus dem Snippet stehen.
  Werkstatt-Varianten (Einsende-Termin oder Wunschtermin im Kaufformular aktiv, z. B. Tuning-Kit mit Einbau):
  kein Datum, nur die Verfügbarkeit, weil das Teil zu uns in die Werkstatt geht (seit 22.10.2026, Texte WERKSTATT unten).

  Texte: locales/*.json unter mrs.liefertag (übersetzbar mit Translate & Adapt), auf die Seite gebracht
  von snippets/mrs-texte.liquid (window.mrsTexte). Fehlen sie, gelten die deutschen Texte unten.

  Regeln (hier anpassen):
  - Bestellschluss 17 Uhr (Zeit Zürich), Versand Mo–Fr. Lieferantenware: pro Marke anders möglich (siehe oben).
  - Zustellung Mo–Fr (Samstagszustellung kostet extra und zählt hier nicht).
  - Keine Zustellung an: Neujahr, Berchtoldstag, Karfreitag, Ostermontag, 1. Mai,
    Auffahrt, Pfingstmontag, 1. August, Weihnachten, Stephanstag.
*/
(function () {
  if (window.mrsLiefertag) return;

  var BESTELLSCHLUSS = 17;
  var TAG = 86400000;

  var TEXTE = {
    lager_heute: 'Bei uns an Lager. Bestellst du heute bis %UHR% Uhr, ist es %WANN% bei dir.',
    lager_jetzt: 'Bei uns an Lager. Bestellst du jetzt, ist es %WANN% bei dir.',
    wann_morgen: 'morgen (%DATUM%)',
    wann_datum: 'am %DATUM%',
    lager_kurz_morgen: 'An Lager · morgen bei dir',
    lager_kurz_datum: 'An Lager · %DATUM% bei dir',
    lieferant_kurz: 'Beim Lieferanten · bis %DATUM% bei dir',
    lieferant_lang: 'Beim Lieferanten verfügbar. Voraussichtlich bis %DATUM% bei dir.',
    datum: '%WOCHENTAG%, %TAG%.%MONAT%.',
    wochentage: 'So,Mo,Di,Mi,Do,Fr,Sa'
  };
  var seite = (window.mrsTexte && window.mrsTexte.liefertag) || {};
  for (var name in TEXTE) {
    if (seite[name]) TEXTE[name] = seite[name];
  }
  var WOCHENTAG = TEXTE.wochentage.split(',');

  // ersetzt %NAME% durch werte.NAME
  function fuellen(vorlage, werte) {
    for (var w in werte) vorlage = vorlage.split('%' + w + '%').join(werte[w]);
    return vorlage;
  }

  function jetztZuerich() {
    var t = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Zurich',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { t[p.type] = p.value; });
    return { datum: Date.UTC(+t.year, +t.month - 1, +t.day), stunde: (+t.hour) % 24 };
  }

  function ostern(j) {
    var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var monat = Math.floor((h + l - 7 * m + 114) / 31), tag = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(j, monat - 1, tag);
  }

  var feiertagCache = {};
  function feiertage(j) {
    if (!feiertagCache[j]) {
      var o = ostern(j);
      feiertagCache[j] = [
        Date.UTC(j, 0, 1), Date.UTC(j, 0, 2), o - 2 * TAG, o + TAG, Date.UTC(j, 4, 1),
        o + 39 * TAG, o + 50 * TAG, Date.UTC(j, 7, 1), Date.UTC(j, 11, 25), Date.UTC(j, 11, 26)
      ];
    }
    return feiertagCache[j];
  }

  function istWerktag(t) {
    var d = new Date(t), w = d.getUTCDay();
    return w !== 0 && w !== 6 && feiertage(d.getUTCFullYear()).indexOf(t) === -1;
  }

  function naechsterWerktag(t) {
    do { t += TAG; } while (!istWerktag(t));
    return t;
  }

  // Bestellschluss als Stunde 1–24, sonst der allgemeine (17 Uhr)
  function schlussVon(schluss) {
    schluss = parseInt(schluss, 10);
    return schluss > 0 && schluss <= 24 ? schluss : BESTELLSCHLUSS;
  }

  // Versand heute, wenn Werktag und vor Bestellschluss, sonst am nächsten Werktag.
  // Zustellung «tage» Werktage nach dem Versandtag. «schluss» optional (Stunde), sonst 17 Uhr.
  function berechne(jetzt, tage, schluss) {
    var heute = istWerktag(jetzt.datum) && jetzt.stunde < schlussVon(schluss);
    var t = heute ? jetzt.datum : naechsterWerktag(jetzt.datum);
    for (var i = 0; i < tage; i++) t = naechsterWerktag(t);
    return { datum: t, heute: heute, morgen: t === jetzt.datum + TAG };
  }

  function format(t) {
    var d = new Date(t);
    return fuellen(TEXTE.datum, { WOCHENTAG: WOCHENTAG[d.getUTCDay()], TAG: d.getUTCDate(), MONAT: d.getUTCMonth() + 1 });
  }

  function text(tage, art, kurz, jetzt, schluss) {
    if (!(tage > 0)) return null;
    // eigener Bestellschluss nur für Lieferantenware, Lagerware immer 17 Uhr
    var l = berechne(jetzt, tage, art === 'lieferant' ? schluss : null);
    var tag = format(l.datum);
    if (art === 'lager') {
      if (kurz) return l.morgen ? TEXTE.lager_kurz_morgen : fuellen(TEXTE.lager_kurz_datum, { DATUM: tag });
      var wann = fuellen(l.morgen ? TEXTE.wann_morgen : TEXTE.wann_datum, { DATUM: tag });
      return fuellen(l.heute ? TEXTE.lager_heute : TEXTE.lager_jetzt, { UHR: BESTELLSCHLUSS, WANN: wann });
    }
    if (art === 'lieferant') {
      return fuellen(kurz ? TEXTE.lieferant_kurz : TEXTE.lieferant_lang, { DATUM: tag });
    }
    return null;
  }

  /*
    Bestell-Eigenschaft «Voraussichtliche Lieferung» (seit 21.10.2026), damit die Angabe der Ampel
    in Bestellung und Bestellbestätigung steht. Der Name bleibt in allen Sprachen deutsch (wie Einsende-Termin),
    im Warenkorb übersetzt ihn snippets/mrs-eigenschaft.liquid. Der Wert ist in der Sprache der Seite.
    Grundlage: snippets/mrs-lieferung.liquid. Verwendet hier (verstecktes Feld im Kaufformular der Produktseite)
    und in assets/mrs-termin-check.js (frisch beim Klick auf «Zur Kasse»).
  */
  var EIGENSCHAFT = 'Voraussichtliche Lieferung';
  var WERT = {
    de: { lieferant: 'bis %DATUM%', datum: '%WOCHENTAG%, %TAG%.%MONAT%.%JAHR%', wochentage: 'So,Mo,Di,Mi,Do,Fr,Sa' },
    fr: { lieferant: "d'ici le %DATUM%", datum: '%WOCHENTAG% %TAG%.%MONAT%.%JAHR%', wochentage: 'dim.,lun.,mar.,mer.,jeu.,ven.,sam.' },
    it: { lieferant: 'entro il %DATUM%', datum: '%WOCHENTAG% %TAG%.%MONAT%.%JAHR%', wochentage: 'dom,lun,mar,mer,gio,ven,sab' },
    en: { lieferant: 'by %DATUM%', datum: '%WOCHENTAG% %TAG%/%MONAT%/%JAHR%', wochentage: 'Sun,Mon,Tue,Wed,Thu,Fri,Sat' }
  };

  function zweistellig(n) { return (n < 10 ? '0' : '') + n; }

  /** Wert der Eigenschaft: art 'lager' → «Mi, 22.10.2026», 'lieferant' → «bis Di, 27.10.2026», 'text' → festtext.
      schluss: Bestellschluss der Marke für Lieferantenware (optional, seit 01.11.2026) */
  function eigenschaft(art, tage, festtext, sprache, schluss) {
    var s = String(sprache || document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
    var w = WERT[s] || WERT.de;
    if (art === 'lager' || art === 'lieferant') {
      tage = parseInt(tage, 10);
      if (!(tage > 0)) return '';
      var d = new Date(berechne(jetztZuerich(), tage, art === 'lieferant' ? schluss : null).datum);
      var datum = fuellen(w.datum, {
        WOCHENTAG: w.wochentage.split(',')[d.getUTCDay()],
        TAG: zweistellig(d.getUTCDate()),
        MONAT: zweistellig(d.getUTCMonth() + 1),
        JAHR: d.getUTCFullYear()
      });
      return art === 'lieferant' ? fuellen(w.lieferant, { DATUM: datum }) : datum;
    }
    if (art === 'text') return String(festtext || '').replace(/\s+/g, ' ').trim();
    return '';
  }

  /*
    Werkstatt-Varianten: Text ohne Datum (DE/FR/IT/EN). Stil: DE du, FR vous, IT tu, EN britisch.
  */
  var WERKSTATT = {
    de: { lager: 'Bei uns an Lager.', lieferant: 'Beim Lieferanten verfügbar.' },
    fr: { lager: 'En stock chez nous.', lieferant: 'Disponible chez le fournisseur.' },
    it: { lager: 'Disponibile nel nostro magazzino.', lieferant: 'Disponibile presso il fornitore.' },
    en: { lager: 'In stock with us.', lieferant: 'Available from our supplier.' }
  };

  function sprache() { return String(document.documentElement.lang || 'de').slice(0, 2).toLowerCase(); }

  // Bereich des Ampel-Blocks: Produkt-Abschnitt oder Quick-Add-Fenster
  function bereichVon(el) {
    return el.closest('.shopify-section, quick-add-drawer, dialog, modal-dialog') || document;
  }

  // Werkstatt-Variante: Einsende-Termin oder Wunschtermin ist im Bereich aktiv (nicht deaktiviert)
  function terminAktiv(bereich) {
    return !!bereich.querySelector('[name="properties[Einsende-Termin]"]:not(:disabled), [name="properties[Wunschtermin]"]:not(:disabled)');
  }

  // Kaufformular zum Ampel-Block (Produktseite, Quick-Add), nicht das Formular für Ratenzahlung
  function kaufformular(el) {
    var bereich = bereichVon(el);
    var formulare = bereich.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < formulare.length; i++) {
      var f = formulare[i];
      if (f.querySelector('[name="id"]') && !/installment/i.test(f.id || '')) return { form: f, bereich: bereich };
    }
    return null;
  }

  function formulareAktualisieren() {
    var gesetzt = [];
    var els = document.querySelectorAll('.backorder[data-lieferung-art]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var k = kaufformular(el);
      if (!k) continue;
      // Werkstatt-Varianten (Einsende-Termin aktiv) und Wunschtermin: keine Lieferangabe
      var wert = terminAktiv(k.bereich) ? '' : eigenschaft(
        el.getAttribute('data-lieferung-art'),
        el.getAttribute('data-lieferung-tage'),
        el.getAttribute('data-lieferung-text'),
        null,
        el.getAttribute('data-lieferung-schluss')
      );
      if (!wert) continue;
      var feld = k.form.querySelector('input[data-mrs-lieferung]');
      if (!feld) {
        feld = document.createElement('input');
        feld.type = 'hidden';
        feld.name = 'properties[' + EIGENSCHAFT + ']';
        feld.setAttribute('data-mrs-lieferung', '');
        k.form.appendChild(feld);
      }
      if (feld.value !== wert) feld.value = wert;
      gesetzt.push(feld);
    }
    // Felder ohne passenden Ampel-Block (z. B. Variante ohne Lieferangabe) entfernen
    var alle = document.querySelectorAll('input[data-mrs-lieferung]');
    for (var j = 0; j < alle.length; j++) {
      if (gesetzt.indexOf(alle[j]) === -1) alle[j].parentNode.removeChild(alle[j]);
    }
  }

  function aktualisieren() {
    try { formulareAktualisieren(); } catch (e) { /* Lieferangabe ist Zusatz, nie die Seite stören */ }
    var jetzt = jetztZuerich();
    var els = document.querySelectorAll('[data-liefertag]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var ziel = el.querySelector('[data-liefertag-text]');
      var art = el.getAttribute('data-liefertag-art');
      var kurz = el.getAttribute('data-liefertag-format') === 'kurz';
      var neu = null;
      // Produktseite und Quick-Add: Werkstatt-Variante ohne Datum
      if (!kurz && terminAktiv(bereichVon(el))) neu = (WERKSTATT[sprache()] || WERKSTATT.de)[art] || null;
      if (!neu) neu = text(parseInt(el.getAttribute('data-liefertag-tage'), 10), art, kurz, jetzt, el.getAttribute('data-liefertag-schluss'));
      if (ziel && neu && ziel.textContent !== neu) ziel.textContent = neu;
    }
  }

  var geplant = false;
  function planen() {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(function () { geplant = false; aktualisieren(); });
  }

  function start() {
    aktualisieren();
    // Variantenwechsel, Filter, Quick-Add und nachgeladene Kacheln ersetzen Teile der Seite.
    // «disabled»: assets/termin-datum.js schaltet den Einsende-Termin je nach Variante ein oder aus.
    new MutationObserver(planen).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    // springt beim Bestellschluss (17 Uhr, RAD-Marken 13 Uhr) und um Mitternacht auf den nächsten Tag
    setInterval(aktualisieren, 60000);
  }

  window.mrsLiefertag = { text: text, berechne: berechne, eigenschaft: eigenschaft, EIGENSCHAFT: EIGENSCHAFT };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();